import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { UserService } from '../user/user-service';

declare var DobryKantor: any;

@Component({
    selector: 'dk-third-party-accept',
    inputs: ['externalCondition','modelGroup','modelName'],
    template: require('./third-party-accept.html'),
    entryComponents: []
})

export class ThirdPartyTransferAcceptComponent implements OnInit, OnChanges  {
    externalCondition: any;
    modelGroup: FormGroup;
    modelName: string;
    thirdPartyRulesUrl: string;
    isRulesAccepted: boolean = false;
 
    constructor(private userService: UserService) { }

    /** waliduj ponownie przy zmianie warunków */
    ngOnChanges(changes: SimpleChanges) {
        if (changes.externalCondition) {
            this.validate();
        }
    }
    
    ngOnInit() {
        this.thirdPartyRulesUrl = DobryKantor.params.cantor.thirdPartyTransferRulesUrl;
        
        this.userService.isRulesAccepted(1).subscribe(value => {
            this.isRulesAccepted = value;
            this.validate();
        });
    }

    validate(){
        if (this.externalCondition && !this.isRulesAccepted ) {
            this.modelGroup.controls[this.modelName].setValidators(Validators.requiredTrue);
        } else {
            this.modelGroup.controls[this.modelName].clearValidators();
            this.modelGroup.controls[this.modelName].updateValueAndValidity({ onlySelf: false, emitEvent: true });
        }
    }
}
